import { z } from 'zod'

export type ContactFormScheme = z.infer<typeof contactFormScheme>

export const contactFormScheme = z.object({
  subject: z
    .string({ required_error: 'Zadajte predmet správy' })
    .min(1, { message: 'Predmet je povinný' })
    .max(200, { message: 'Predmet môže mať maximálne 200 znakov' }),
  body: z
    .string({ required_error: 'Zadajte obsah správy' })
    .min(10, { message: 'Správa musí mať minimálne 10 znakov' })
    .max(2000, { message: 'Správa môže mať maximálne 2000 znakov' }),
})
